import { useState, useEffect, ChangeEvent } from 'react';
import { apiPaths } from '../../../../../service/apiPaths';
import ApiService from '../../../../../service/ApiService';
import { IAddProject, IProject } from '../../Project.props';
import { SubmitHandler } from 'react-hook-form';
import toast from 'react-hot-toast';

const useEditProject = (projectId: string , setMethod: () => void) => {
  const [formData, setFormData] = useState<IAddProject>({
    name: "",
    description: "",
    gitfeld: "",
    status: "Active",
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [project, setProject] = useState<IProject | null>(null);
  useEffect(() => {
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
    setLoading(true)
    try {
      const data = await ApiService({
        method: "GET",
        endpoint: `${apiPaths.getProjectById}${projectId}`,
      });
      if (!data) {
        toast.error("Project not found");
        return;
      }
      setProject(data);
      populateFormData(data);
    } catch (error) {
      toast.error(`Error - ${error}`,{
        duration: 5000,
      });
      console.error("Error fetching data:", error);
    }finally{
      setLoading(false)
    }
  };

  const populateFormData = (projectData: IProject) => {
    const status =
      projectData.status === "InActive" || projectData.status === "Active"
        ? projectData.status
        : "Active";
    setFormData({
      name: projectData.name,
      description: projectData.description,
      gitfeld: projectData.gitfeld ?? "",
      status,
    });
  };

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { id, value, name } = e.target;
    const key = id || name;
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit: SubmitHandler<IAddProject> = async () => {
    setLoading(true);
    try {
      const response = await ApiService({
        method: 'PUT',
        endpoint: `${apiPaths.updateProject}${projectId}`,
        data: {
          name: formData.name,
          description: formData.description,
          gitfeld: formData.gitfeld,
          status: formData.status,
        },
      });
      if (response !== 'undefined') {
        toast.success('Project updated successfully', {
          duration: 5000,
        });
        setTimeout(() => {
          setMethod();
        }, 1500);
      }
    } catch (error) {
      toast.error(`Error - ${error}`,{
        duration: 5000,
      });
      console.error("Error updating project:", error);
    }finally{
      setLoading(false)
    }
  };
  

  return {
    loading,
    formData,
    project,
    handleChange,
    handleSubmit,
  };
};
export default useEditProject;
